import { z } from 'zod';

export const dealerSchema = z.object({
  name: z.string().min(1, 'validation.required'),
  code: z.string().min(1, 'validation.required'),
  licenseValidUntil: z.string().min(1, 'validation.required'),
  tenantLimit: z.union([z.string(), z.number()]).optional(),
});
